export function getUrlParam(name) {
    const result = location.href.match(new RegExp("[?&]" + name + "=([^&]+)", "i"));
    if (result == null || result.length < 1) {
        return "";
    }
    return result[1];

}
